import moment from "moment";
import React from "react";
import Loader from "react-loader-spinner";

export default function FilesTable(props) {
  const { tableHeader, data, dataKey, loader, header } = props;

  return (
    <div className="filesdata-table">
      <p className="block-title">{tableHeader}</p>
      <table striped bordered hover className="customTable table">
        <tr>
          <th>{header[0]}</th>
          <th>{header[1]}</th>
          <th style={{textAlign: "center"}}>{header[2]}</th>
        </tr>
        {loader ? <tr className="height100"><th colSpan={3}>
          <Loader className="loader trans-loader files-table-loader"
      type="ThreeDots"
      color="#9c1d26"
      width={100}
      visible={loader}
      /></th> </tr>
        : <>{
              data.length > 0
            ? data.map((val, index) => {
              return (
                <tr key={index}>
                  <td style={{maxWidth:150, wordWrap: "break-word"}}>{val[dataKey[0]]}</td>
                  <td style={{maxWidth:120, textAlign:'center'}}>{val[dataKey[1]] ? moment(val[dataKey[1]]).format('DD/MM/YYYY HH:mm:ss') : '--'}</td>
                  <td style={{ maxWidth:100, fontWeight: "bold", color: "black", textAlign: "center" }}>{val[dataKey[2]]}</td>
                </tr>
              );
            })
            : <tr className="height100">
              <td colSpan={3} style={{ textAlign: "center" }}>Record Not Found</td>
            </tr>
        }</>
      }
      </table>
    </div>
  );
}
